/* eslint-disable */
"use strict";

import ODLayoutHeader from "./header.js";
import ODCard from "./../../components/card.js";
import { ODUtil } from "./../../components/util.js";
import ODLayoutSubheader from "./subheader.js";

var ODLayoutStickyCard = function() {
    // Private properties
	var _element;
    var _object;

	// Private functions
	var _init = function() {
		var offset = 300;

		if (typeof ODLayoutHeader !== 'undefined') {
			offset = ODLayoutHeader.getHeight();
		}

        _object = new ODCard(_element, {
			sticky: {
				offset: offset,
				zIndex: 90,
				position: {
					top: function() {
						var pos = 0;
                        var body = ODUtil.getBody();

						if (ODUtil.isBreakpointUp('lg')) {
							if (typeof ODLayoutHeader !== 'undefined' && ODLayoutHeader.isFixed()) {
								pos = pos + ODLayoutHeader.getHeight();
							}

							if (typeof ODLayoutSubheader !== 'undefined' && ODLayoutSubheader.isFixed()) {
								pos = pos + ODLayoutSubheader.getHeight();
							}
						} else {
							if (typeof ODLayoutHeader !== 'undefined' && ODLayoutHeader.isFixedForMobile()) {
								pos = pos + ODLayoutHeader.getHeightForMobile();
							}
						}

						pos = pos - 1; // remove header border width

						return pos;
					},
					left: function(card) {
						return ODUtil.offset(_element).left;
					},
					right: function(card) {
						var body = ODUtil.getBody();

						var cardWidth = parseInt(ODUtil.css(_element, 'width'));
						var bodyWidth = parseInt(ODUtil.css(body, 'width'));
						var cardOffsetLeft = ODUtil.offset(_element).left;

						return bodyWidth - cardWidth - cardOffsetLeft;
					}
				}
			}
		});

		_object.initSticky();

		ODUtil.addResizeHandler(function() {
			_object.updateSticky();
		});
	}

    // Public methods
	return {
		init: function(id) {
            _element = ODUtil.getById(id);

            if (!_element) {
                return;
            }

            // Initialize
			_init();
		},

		update: function() {
			if (_object) {
				_object.updateSticky();
			}
		}
	};
}();

// Webpack support
if (typeof module !== 'undefined') {
	// module.exports = ODLayoutStickyCard;
}

export default ODLayoutStickyCard;
